import { ApiClient } from '~/infrastructure/api'
import type { Course, Lesson } from '~/types/lesson.types'

export function createLessonService(apiUrl: string) {
  const client = new ApiClient(apiUrl)

  async function getCourseWithLessons(courseSlug: string): Promise<Course> {
    const res = await client.get<{ data: Course }>(`/courses/details/${courseSlug}`)
    return res.data
  }

  async function getLessons(courseSlug: string): Promise<Lesson[]> {
    const course = await getCourseWithLessons(courseSlug)
    return course.lessons ?? []
  }

  async function getLessonBySlug(courseSlug: string, slug: string): Promise<Lesson | null> {
    const lessons = await getLessons(courseSlug)
    return (
      lessons.find(l => String(l.lesson_order) === slug || l.lesson_token === slug) ?? null
    )
  }

  async function getLessonById(lessonId: string): Promise<Lesson> {
    const res = await client.get<{ data: Lesson }>(`/lessons/${lessonId}`)
    return res.data
  }

  return { getLessons, getLessonBySlug, getLessonById, getCourseWithLessons }
}
